import { Link } from "react-router-dom";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="lw-footer border-t border-border bg-card">
      <div className="lw-footer-inner container mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 px-4 py-3">
        <p className="text-xs text-muted-foreground">
          © {currentYear} ListWeave. All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
        </div>
      </div>
    </footer>
  );
}
